module.exports = __webpack_public_path__ + "static/media/intro.fbeb0b07.mp3";